import * as http from 'axios'
export const getTiposRegistro = (q) => http.get(`/tipoRegistros?sort=nome&nome__regex=/.*${q}.*/i`)
export const persist = (tipoRegistro) => {
  if (tipoRegistro._id) {
    return http.put(`/tipoRegistros/${tipoRegistro._id}`, tipoRegistro)
  } else {
    return http.post('/tipoRegistros', tipoRegistro)
  }
}
export const remove = (tipoRegistro) => http.delete(`/tipoRegistros/${tipoRegistro._id}`)



// WEBPACK FOOTER //
// ./src/store/tipoRegistro/services.js